module.exports = __webpack_public_path__ + "static/media/mrright-logo-horiz-color.d302da15.png";